import Api from '../../lib/api';

export const SYSTEM_INFO = {
	start: 'fetch_start/system_info',
	end: 'fetch_end/system_info',
	success: 'fetch_success/system_info',
	failed: 'fetch_failed/system_info',
	setSystemInfo: 'set_current_year'
};

export const systemInfoFetchStart = () => ({
	type: SYSTEM_INFO.start
});

export const systemInfoFetchEnd = () => ({
	type: SYSTEM_INFO.end
});

export const systemInfoFetchSuccess = (data, parsedList) => (
	{
		type: SYSTEM_INFO.success,
		data,
		parsedList
	});

export const systemInfoFetchFailed = (error) => ({
	type: SYSTEM_INFO.failed,
	error
});

export const fetchSystemInfo = () => (dispatch) => {
	dispatch(systemInfoFetchStart());
	return Api.get(Api.API_SYSTEM_INFO()).then(response => {
		if (response.success && response.data) {
			dispatch(systemInfoFetchEnd());
			dispatch(systemInfoFetchSuccess(response.data.data));
		}
		else {
			dispatch(systemInfoFetchEnd());
		}
	}).catch((exception) => {
		dispatch(systemInfoFetchEnd());
		dispatch(systemInfoFetchFailed());
	});
};



// WEBPACK FOOTER //
// ./shared/actions/getSystemInfo.js